import { ref, computed, watch, provide, nextTick, onMounted } from 'vue';
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-07b941cd"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "mainpage"
};
const _hoisted_2 = {
  class: "card"
};
const _hoisted_3 = {
  key: 0,
  class: "back-box",
  style: {
    "margin-bottom": "12px"
  }
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 苹果商品配置 ")], -1));
const _hoisted_5 = {
  class: "optionLabel"
};
const _hoisted_6 = {
  class: "optionDescribtion"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "内购ID自动生成规则：包名+内购名称，全小写，不超过100字符", -1));
const _hoisted_8 = {
  key: 3,
  style: {
    "margin-left": "80px",
    "color": "rgba(0, 0, 0, 0.45)"
  }
};
const _hoisted_9 = {
  class: "card priceCard"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}), /*#__PURE__*/_createTextVNode(" 价格设置 ")], -1));
const _hoisted_11 = {
  class: "taxRateBox"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "rate-tips"
}, "开启后新加坡本地价格将自动上调9%，以规避新加坡地区GST税费", -1));
const _hoisted_13 = {
  class: "card current-price"
};
const _hoisted_14 = {
  class: "title"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}, null, -1));
const _hoisted_16 = {
  key: 0,
  style: {
    "text-align": "right"
  }
};
const _hoisted_17 = {
  class: "price-list"
};
const _hoisted_18 = {
  key: 0,
  class: "l-title"
};
const _hoisted_19 = {
  class: "name"
};
const _hoisted_20 = {
  class: "price"
};
const _hoisted_21 = {
  class: "area"
};
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订阅价格", -1));
const _hoisted_23 = {
  key: 0
};
const _hoisted_24 = {
  key: 0,
  class: "desc"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("li", {
  class: "l-title"
}, "当前价格", -1));
const _hoisted_26 = {
  class: "name"
};
const _hoisted_27 = {
  class: "price"
};
const _hoisted_28 = {
  class: "area"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "订阅价格", -1));
const _hoisted_30 = {
  key: 0,
  class: "desc"
};
const _hoisted_31 = {
  class: "card priceCard"
};
const _hoisted_32 = {
  class: "third-party-payment-item"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "third-party-payment-tips"
}, " 该功能尚在选品测试阶段，请确认游戏已接入「第三方支付」功能，否则配置无效； ", -1));
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "enjoypay-tips-text"
}, " *三方价格不得低于官方价格的7折，且建议价格设置不低于1.99美元，否则enjoypay佣金将高于iOS; ", -1));
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "enjoypay-tips-text"
}, " *折扣描述会显示在游戏收银台页面，若需自定义描述，建议使用英文谨慎修改; ", -1));
const _hoisted_36 = {
  class: "card"
};
const _hoisted_37 = {
  class: "title"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lbk"
}, null, -1));
const _hoisted_39 = {
  style: {
    "float": "right"
  }
};
const _hoisted_40 = {
  key: 0,
  class: "ticket_add"
};
const _hoisted_41 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "如需为订阅商品设置「新用户」促销价格，请添加优惠方案", -1));
const _hoisted_42 = {
  key: 1,
  class: "ticket_form"
};
const _hoisted_43 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_44 = {
  class: "submitBlock"
};
const _hoisted_45 = {
  class: "selectBox"
};
import { Select, SelectOption } from 'ant-design-vue';
import { PlusOutlined } from '@ant-design/icons-vue';
import useGetSelect from '@/hooks/useGetSelect';
import MultiComponents from './components/MultiComponents1.vue';
import PriceBlock2 from './components/PriceBlock2.vue';
import PriceBlock1 from './components/PriceBlock1.vue';
import dayjs from 'dayjs';
import DyzModal from './components/dyzModal.vue';
import SelectModal from './components/SelectModal.vue';
import RecordDrawer from './components/RecordDrawer.vue';
import { cloneDeep, debounce } from 'lodash';
import { awaitWrap, getNode, OK, reportEvent } from '@/common';
import { getLadderPrice } from '@/api/goodsInfo';
import useDetailHooks from './hooks/useDetailHooks';
import { getSubscriptionGroupList } from '@/api/goodsInfo';
import { queryPkgInfo, queryGoods, addGoods, updGoods, getLastLangInfo } from '@/api/goodsSetting';
import { useRoute, useRouter } from 'vue-router';
import { QuestionCircleOutlined, DeleteOutlined, RestOutlined } from '@ant-design/icons-vue';
import { message } from 'ant-design-vue';
import EditModal from './components/EditModal.vue';
import { defineComponent } from 'vue';
const __default__ = defineComponent({
  name: 'goodsSettingDetail'
});
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const originLoading = ref(false);
    const priceTrend = ref(false);
    const dataText = ref('请选择结束日期');
    const endDate = ref();
    const endDateOpen = ref(false);
    const filterOption = (input, option) => {
      return option.regionName.indexOf(input) >= 0;
    };
    // 适用范围弹窗
    const visible = ref(false);
    //
    const showCountryModal = () => {
      visible.value = true;
    };
    const saveCountry = value => {
      prodGracePlan.value.regionConfigList = value;
      prodGracePlan.value.productNativePrice = yhConturyPrice.value;
    };
    // 比较两个字符串数字，1.0 和 1.00 ，是否相等
    function compareStringNumbers(str1, str2) {
      // 将字符串转换为数字
      let num1 = parseFloat(str1);
      let num2 = parseFloat(str2);
      // 比较两个数字是否相等
      return num1 === num2;
    }
    const route = useRoute();
    const router = useRouter();
    const {
      countryToCoin,
      getCountryCoinOptions
    } = useGetSelect();
    const {
      prodTypeOptions,
      basePlanDurationType,
      verifyNumber,
      validateIosPid
    } = useDetailHooks();
    const disabled = ref(false); // 禁用改动
    const modalVisible = ref(false); // 弹窗显示隐藏
    const priceTabKey = ref('1');
    const thirdPartyPayment = ref({
      enabled: false,
      prodPrice: '',
      promotionDesc: ''
    });
    const showPriceWarn = computed(() => {
      const officialPrice = parseFloat(settingForm.value.defaultPriceTier);
      const thirdPrice = parseFloat(thirdPartyPayment.value.prodPrice);
      if (!thirdPrice || !officialPrice || isNaN(officialPrice) || isNaN(thirdPrice)) return false;
      return thirdPrice < officialPrice * 0.7 || thirdPrice < 1.99;
    });
    const enjoyPayDiscountNum = computed(() => {
      const officialPrice = parseFloat(settingForm.value.defaultPriceTier);
      const thirdPrice = parseFloat(thirdPartyPayment.value.prodPrice);
      if (!thirdPrice || !officialPrice || isNaN(officialPrice) || isNaN(thirdPrice)) return null;
      return Math.round((officialPrice - thirdPrice) / officialPrice * 100);
    });
    const calcPromotionDesc = debounce(() => {
      const officialPrice = parseFloat(settingForm.value.defaultPriceTier);
      const thirdPrice = parseFloat(thirdPartyPayment.value.prodPrice);
      if (!thirdPrice || !officialPrice || isNaN(officialPrice) || isNaN(thirdPrice)) return;
      const savedAmount = (officialPrice - thirdPrice).toFixed(2);
      const rate = Math.round((officialPrice - thirdPrice) / officialPrice * 100);
      thirdPartyPayment.value.promotionDesc = `You will save $${savedAmount} on this purchase, a discount of about ${rate}%`;
    }, 300);
    watch(() => thirdPartyPayment.value.prodPrice, calcPromotionDesc);
    provide('basePlanDurationType', basePlanDurationType);
    const timeStep = [{
      label: '一周',
      value: 'ONE_WEEK'
    }, {
      label: '一个月',
      value: 'ONE_MONTH'
    }, {
      label: '两个月',
      value: 'TWO_MONTHS'
    }, {
      label: '三个月',
      value: 'THREE_MONTHS'
    }, {
      label: '六个月',
      value: 'SIX_MONTHS'
    }, {
      label: '一年',
      value: 'ONE_YEAR'
    }];
    const textMap = {
      APPROVED: '已上架',
      DEVELOPER_ACTION_NEEDED: '待开发人员处理',
      DEVELOPER_REMOVED_FROM_SALE: '待开发者处理',
      IN_REVIEW: '待提交',
      MISSING_METADATA: '待提交元数据',
      PENDING_BINARY_APPROVAL: '待提交二进制',
      PROCESSING_CONTENT: '正在处理',
      READY_TO_SUBMIT: '准备提交',
      REJECTED: '被拒绝',
      REMOVED_FROM_SALE: '被下架',
      WAITING_FOR_REVIEW: '正在等待审核',
      WAITING_FOR_UPLOAD: '待上传'
    };
    const statusText = computed(() => {
      return textMap[settingForm.value.appleState] || settingForm.value.appleState;
    });
    // 优惠开始时间
    const disabledDate = current => {
      return current && current < dayjs().startOf('day');
    };
    // 优惠结束时间 要大于开始时间和当日
    const disabledDate1 = current => {
      return current && (current < dayjs(prodGracePlan.value.startDate).endOf('day') || current < dayjs().endOf('day'));
    };
    const queryParams = ref({
      prodChnl: '',
      dbtId: '',
      id: null,
      type: '' // 类型
    });
    const saveNext = ref(false); // 是否连续创建，保存后留在本页，清空配置信息，保留其他例如价格信息
    const multiComponentRef = ref(null); // 组件ref
    const priceBlockRef = ref(null);
    const myFormRef = ref(null);
    const dzmodal = ref(); // 订阅组
    const lastLangInfo = ref([]);
    const spinning = ref(false); // 本地价格加载中
    const yhShow = ref(false); // 优惠方案显示隐藏
    const showLastLangInfo = ref(false); // 历史语言信息显示隐藏
    const yhShowChange = flag => {
      var _priceBlockRef$value;
      const arr1 = (_priceBlockRef$value = priceBlockRef.value) === null || _priceBlockRef$value === void 0 ? void 0 : _priceBlockRef$value.showData.map(item => item.regionCode);
      arr1.push(defaultCountryId.value);
      prodGracePlan.value = {
        regionConfigList: arr1,
        type: 'FREE_TRIAL',
        duration: 'THREE_DAYS',
        productNativePrice: yhConturyPrice.value.map(item => ({
          ...item
        })),
        startDate: '',
        endDate: ''
      };
      yhShow.value = flag;
    }; // 优惠方案添加删除
    const prodGracePlan = ref({
      regionConfigList: [],
      type: 'FREE_TRIAL',
      duration: 'THREE_DAYS',
      productNativePrice: [],
      startDate: '',
      endDate: ''
    }); // 优惠设置
    const yhContury = computed(() => {
      var _priceBlockRef$value$;
      const arr = priceBlockRef.value ? (_priceBlockRef$value$ = priceBlockRef.value.showData) === null || _priceBlockRef$value$ === void 0 ? void 0 : _priceBlockRef$value$.filter(item => prodGracePlan.value.regionConfigList.includes(item.regionCode)) : [];
      const index = conturyPrice.value.findIndex(item => item.prodPrice === settingForm.value.defaultPriceTier);
      if (index !== -1) {
        arr.push(conturyPrice.value[index]);
      }
      // arr.push()
      return arr || [];
    }); // 适用范围 是价格设置里的本地价格列表
    const taxRateSwitch = ref(true); // 新加坡税率开关
    const cCountry = ref('');
    // 查询到的所有地区值
    const allAreaList = computed(() => {
      var _priceBlockRef$value2;
      const arr = (_priceBlockRef$value2 = priceBlockRef.value) === null || _priceBlockRef$value2 === void 0 ? void 0 : _priceBlockRef$value2.showData.map(item => {
        return item.regionName;
      });
      return arr;
    });
    // 最初的价格历史合集
    const originPriceList = ref([]);
    const allData = computed(() => {
      var _priceBlockRef$value3;
      const arr = (_priceBlockRef$value3 = priceBlockRef.value) === null || _priceBlockRef$value3 === void 0 ? void 0 : _priceBlockRef$value3.showData.map(item => item);
      const index = conturyPrice.value.findIndex(item => item.prodPrice === settingForm.value.defaultPriceTier);
      if (index !== -1) {
        arr.push(conturyPrice.value[index]);
      }
      return arr;
    }); // 适用范围弹窗的数据
    const yhConturyPrice = computed(() => {
      var _priceBlockRef$value4;
      const arr = (_priceBlockRef$value4 = priceBlockRef.value) === null || _priceBlockRef$value4 === void 0 ? void 0 : _priceBlockRef$value4.showData.filter(item => prodGracePlan.value.regionConfigList.includes(item.regionCode));
      const index = conturyPrice.value.findIndex(item => item.prodPrice === settingForm.value.defaultPriceTier);
      if (index !== -1) {
        arr.push(conturyPrice.value[index]);
      }
      return arr;
    }); // 本地价格 是适用范围的列表
    const saveLoading = ref(false); // 保存按钮可用性
    const defaultCountry = ref([]); // 默认价格国家
    const defaultCountryId = ref('USA'); // 默认价格国家ID
    const conturyPrice = ref([]); // 默认价格列表
    const conturyPriceLoading = ref(false); // 获取默认价格loading
    const futurePriceList = ref([]); // 即将生效价格列表
    const cPriceList = ref([{
      title: '',
      money: '',
      area: '',
      areaList: [],
      desc: ''
    }]);
    const isDeletedShow = ref(false);
    const isOriginHave = ref(true);
    const originObj = ref({});
    const dyList = ref([]); // 订阅列表
    const clickDzAdd = () => {
      modalVisible.value = true;
      dzmodal.value.openModal();
    }; // 打开订阅组弹窗
    // 计算默认价格国家
    const calcSelectOptions = async _ => {
      var _priceBlockRef$value5;
      // 重置默认价格层级为空白，准备加载新的价格信息
      settingForm.value.defaultPriceTier = '';
      // 初始化国家价格列表为空数组
      conturyPrice.value = [];
      // 重置价格块的表单状态，清除之前的价格数据
      (_priceBlockRef$value5 = priceBlockRef.value) === null || _priceBlockRef$value5 === void 0 || _priceBlockRef$value5.reset();
      // 重置产品优惠计划的区域配置列表为空数组
      prodGracePlan.value.regionConfigList = [];
      // 开始加载国家价格数据，设置加载状态为true
      conturyPriceLoading.value = true;
      // 异步获取梯度价格信息，根据当前选定的DBT ID、区域代码和产品类型
      const res = await getLadderPrice({
        dbtId: queryParams.value.dbtId,
        regionCode: defaultCountryId.value,
        prodType: settingForm.value.prodType
      });
      // 结束加载状态，设置为false
      conturyPriceLoading.value = false;
      // 根据接口返回码处理返回的数据，若成功则更新国家价格列表，否则清空列表
      if (res.code === '0') {
        conturyPrice.value = res.data;
      } else {
        conturyPrice.value = [];
      }
    };
    // 变更默认价格需要重新请求价目表
    const changeProdPrice = async (_, isDetail = false) => {
      var _priceBlockRef$value6;
      settingForm.value.defaultPriceTier = _;
      if (!settingForm.value.defaultPriceTier) {
        message.warning('请先填写默认价格');
        return;
      }
      const item = conturyPrice.value.find(item => compareStringNumbers(item.prodPrice, settingForm.value.defaultPriceTier));
      if (item && item.prodPrice && parseFloat(item.prodPrice) <= 0) {
        settingForm.value.prodPrice = '';
        return;
      } else {
        settingForm.value.prodPrice = item.prodPrice;
      }
      const flag = await verifyNumber({
        prodChnl: queryParams.value.prodChnl,
        prodPrice: settingForm.value.prodPrice,
        prodPriceCurrency: settingForm.value.prodPriceCurrency,
        prodType: settingForm.value.prodType
      });
      if (!flag) {
        settingForm.value.prodPrice = '';
        return;
      }
      let params = {
        pkg: settingForm.value.pkg,
        prodChnl: queryParams.value.prodChnl,
        prodPrice: settingForm.value.prodPrice,
        prodType: settingForm.value.prodType,
        dbtId: queryParams.value.dbtId,
        prodPriceCurrency: item.prodPriceCurrency
      };
      // if (isShowTicket.value) {
      params.priceId = item.priceId;
      // } else {
      params.priceTier = item.priceTier;
      // }
      // 增加开关控制参数
      if (showRateSwitch.value) {
        params = Object.assign({}, params, {
          applySgtAdjustment: taxRateSwitch.value
        });
      }
      (_priceBlockRef$value6 = priceBlockRef.value) === null || _priceBlockRef$value6 === void 0 || _priceBlockRef$value6.reset();
      prodGracePlan.value.regionConfigList = [];
      try {
        spinning.value = true;
        if (isDetail !== true) {
          var _priceBlockRef$value7;
          await ((_priceBlockRef$value7 = priceBlockRef.value) === null || _priceBlockRef$value7 === void 0 ? void 0 : _priceBlockRef$value7.queryData(params)); // 价格列表初始化
        }
      } finally {
        spinning.value = false;
      }
      calcPromotionDesc();
    };
    // 处理下拉框change事件，不直接修改下拉值
    const handlePriceTierChange = async () => {
      await changeProdPrice(settingForm.value.defaultPriceTier);
    };
    const isShowTicket = computed(() => {
      let flag1 = settingForm.value.prodType === '32'; // 是否是自动续期订阅
      return flag1;
    });
    const changeProdType = () => {
      var _priceBlockRef$value8;
      priceTabKey.value = '1';
      conturyPrice.value = [];
      defaultCountryId.value = '';
      settingForm.value.defaultPriceTier = '';
      (_priceBlockRef$value8 = priceBlockRef.value) === null || _priceBlockRef$value8 === void 0 || _priceBlockRef$value8.reset();
      defaultCountryId.value = 'USA';
      calcSelectOptions();
    }; // 商品类型变更 默认价格重置
    const settingForm = ref({
      prodType: '',
      pkg: '',
      prodId: '',
      remark: '',
      productNativeInfo: [{
        key: 1,
        lang: 'en-US',
        langOptions: [],
        prodDescription: '',
        prodName: '',
        error: ''
      }],
      prodPrice: '',
      prodPriceCurrency: 'USD',
      prodBasePlan: {
        // 订阅组
        id: '',
        subscriptionType: '1',
        subscriptionPeriod: ''
      },
      defaultPriceTier: '',
      appleState: '' // 商品状态
    });
    const getPkg = async () => {
      const res = await queryPkgInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      });
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        settingForm.value.pkg = res.data.pkg;
        settingForm.value.prodId = res.data.pkg;
        settingForm.value.prodPriceCurrency = countryToCoin.value[res.data.country];
        cCountry.value = res.data.country;
        defaultCountry.value = res.data.defaultCountryOptions.map(item => {
          return {
            regionCode: item.regionCode,
            regionName: item.regionName + '(' + item.chnlCurrency + ')',
            prodPriceCurrency: item.prodPriceCurrency
          };
        });
      }
    }; //查询包名等信息
    const cancel = () => {
      window.history.go(-1);
    }; // 取消逻辑
    const setProdId = e => {
      var _e;
      e = e.trim();
      if (queryParams.value.id || !((_e = e) !== null && _e !== void 0 && _e.length)) return; // 编辑时不允许修改内购ID
      try {
        var _getStr$match;
        let getStr = e.toLowerCase().replace(/\s*/g, '');
        getStr = ((_getStr$match = getStr.match(/[a-z0-9\.]/g)) === null || _getStr$match === void 0 ? void 0 : _getStr$match.join('')) || '';
        let countStr = 140 - settingForm.value.pkg.length - 1;
        settingForm.value.prodId = settingForm.value.pkg + '.' + getStr.slice(0, countStr);
      } catch (error) {}
      // myFormRef.value.validate()
    }; // 内购ID拼接
    const checker = () => {
      var _priceBlockRef$value9;
      for (let i = 0; i < settingForm.value.productNativeInfo.length; i++) {
        var _item$prodName, _item$prodDescription, _item$prodName2, _item$prodDescription2;
        let item = settingForm.value.productNativeInfo[i];
        if (item.prodName.length < 2) {
          message.error('商品名称长度不能小于2');
          return false;
        }
        if (!item.lang || !item.prodDescription || !item.prodName) {
          message.error('商品信息的语言，商品名称，商品描述需要正确填写完整');
          return false;
        }
        if (((_item$prodName = item.prodName) === null || _item$prodName === void 0 ? void 0 : _item$prodName.length) > 30) {
          item.error = '商品名称不能超过30个字符';
        }
        if (((_item$prodDescription = item.prodDescription) === null || _item$prodDescription === void 0 ? void 0 : _item$prodDescription.length) > 45) {
          item.error = '商品描述不能超过45个字符';
        }
        if (((_item$prodName2 = item.prodName) === null || _item$prodName2 === void 0 ? void 0 : _item$prodName2.length) <= 30 && ((_item$prodDescription2 = item.prodDescription) === null || _item$prodDescription2 === void 0 ? void 0 : _item$prodDescription2.length) <= 45) {
          item.error = '';
        }
      } // 商品信息校验
      if (settingForm.value.productNativeInfo.filter(item => item.error).length) {
        return false;
      }
      let getPriceArr = (_priceBlockRef$value9 = priceBlockRef.value) === null || _priceBlockRef$value9 === void 0 ? void 0 : _priceBlockRef$value9.originData;
      if (!getPriceArr.length) {
        message.error('价格信息表内容不能为空');
        return false;
      } else {
        for (let i = 0; i < getPriceArr.length; i++) {
          let item = getPriceArr[i];
          if (!item.prodPrice) {
            message.error('价格信息内容请填写完整');
            return false;
          }
        } // 价格信息校验
      }
      return true;
    }; // 自定义部分校验
    const refreshDy = () => {
      getPicker();
    }; // 刷新订阅组列表
    const getPicker = async () => {
      const res = await getSubscriptionGroupList({
        dbtId: queryParams.value.dbtId
      });
      dyList.value = [];
      if (res.code === '0') {
        dyList.value = res.data;
      }
    };
    // 处理保存字段
    const buildParams = () => {
      var _priceBlockRef$value10;
      const item = conturyPrice.value.find(item => compareStringNumbers(item.prodPrice, settingForm.value.defaultPriceTier));
      let params = {
        ...settingForm.value,
        regionCode: item.regionCode,
        prodPriceCurrency: item.prodPriceCurrency,
        prodChnl: queryParams.value.prodChnl,
        dbtId: queryParams.value.dbtId,
        productNativePrice: (_priceBlockRef$value10 = priceBlockRef.value) === null || _priceBlockRef$value10 === void 0 ? void 0 : _priceBlockRef$value10.originData,
        defaultPriceTier: item.priceTier,
        defaultPriceId: item.priceId
      };
      switch (settingForm.value.prodType) {
        case '20':
        case '10':
          delete params.prodBasePlan;
          break;
        case '31':
          params.prodBasePlan = {
            id: '',
            subscriptionType: 0
          };
          break;
        case '32':
          params.prodBasePlan = {
            id: settingForm.value.prodBasePlan.id,
            subscriptionType: 1,
            subscriptionPeriod: settingForm.value.prodBasePlan.subscriptionPeriod
          };
          params.prodGracePlan = yhShow.value ? {
            ...prodGracePlan.value,
            startDate: dayjs(prodGracePlan.value.startDate).format('YYYY-MM-DD'),
            endDate: prodGracePlan.value.endDate ? dayjs(prodGracePlan.value.endDate).format('YYYY-MM-DD') : '',
            regionConfigList: yhConturyPrice.value.map(item => ({
              regionCode: item.regionCode
            })),
            productNativePrice: yhConturyPrice.value.map(k => ({
              ...k,
              discountType: 'FREE_TRIAL'
            }))
          } : null;
          break;
      }
      const isEditing = !!queryParams.value.id;
      let marketProdInfoModified = false;
      if (isEditing) {
        var _priceBlockRef$value$2, _priceBlockRef$value11;
        // 编辑时要判断苹果官方价格的备注、商品信息、价格设置有没有改变，有的话需要设置marketProdInfoModified为true
        const origin = originObj.value;
        const currentPriceList = (_priceBlockRef$value$2 = (_priceBlockRef$value11 = priceBlockRef.value) === null || _priceBlockRef$value11 === void 0 ? void 0 : _priceBlockRef$value11.originData) !== null && _priceBlockRef$value$2 !== void 0 ? _priceBlockRef$value$2 : [];
        const pickNameFields = list => list.map(({
          lang,
          prodDescription,
          prodName
        }) => ({
          lang,
          prodDescription,
          prodName
        }));
        const nameChanged = JSON.stringify(pickNameFields(settingForm.value.productNativeInfo)) !== JSON.stringify(pickNameFields(origin.productNativeInfo));
        const defaultPriceChanged = !compareStringNumbers(settingForm.value.defaultPriceTier, origin.prodPrice);
        const priceListChanged = (() => {
          const currentKeys = currentPriceList.map(i => `${i.regionCode}:${i.prodPrice}`).sort().join(',');
          const originKeys = origin.productNativePrice.map(i => `${i.regionCode}:${i.prodPrice}`).sort().join(',');
          return currentKeys !== originKeys;
        })();
        const remarkChanged = settingForm.value.remark !== origin.remark;
        marketProdInfoModified = nameChanged || defaultPriceChanged || priceListChanged || remarkChanged;
      }
      if (settingForm.value.prodType === '20' && thirdPartyPayment.value.prodPrice) {
        params.channelPrices = {
          priceInfo: {
            enjoy_pay: {
              prodPriceCurrency: 'USD',
              enableThirdPay: thirdPartyPayment.value.enabled,
              prodPrice: thirdPartyPayment.value.prodPrice,
              promotionDesc: thirdPartyPayment.value.promotionDesc,
              promotionDiscount: enjoyPayDiscountNum.value != null ? `${enjoyPayDiscountNum.value}%` : ''
            }
          },
          extInfo: {
            marketProdInfoModified
          }
        };
      }
      return params;
    };
    // 保存商品信息
    const save = async () => {
      try {
        // 校验苹果官方价格默认价格（仅当前在 enjoypay tab 且未填时提示）
        if (priceTabKey.value === '2' && !settingForm.value.defaultPriceTier) {
          priceTabKey.value = '1';
        }
        const valid = await myFormRef.value.validate();
        if (!valid || !checker()) return;
        // 检查开始时间和结束时间
        //结束时间不能小于开始时间
        //开始时间不能小于当日
        if (yhShow.value && !prodGracePlan.value.startDate) {
          message.error('请选择开始时间');
          return;
        }
        if (prodGracePlan.value.startDate && prodGracePlan.value.endDate) {
          if (dayjs(prodGracePlan.value.startDate).isAfter(dayjs(prodGracePlan.value.endDate))) {
            message.error('结束时间不能小于开始时间');
            return;
          }
          if (dayjs(prodGracePlan.value.startDate).isBefore(dayjs().startOf('day'))) {
            message.error('开始时间不能小于当日');
            return;
          }
        }
        let params = buildParams();
        if (settingForm.value.prodType == '32' && queryParams.value.type == 'edit' && futurePriceList.value.length > 0
        // &&
        // settingForm.value.appleState == 'APPROVED'
        ) {
          const {
            regionCode,
            prodPrice,
            prodPriceCurrency,
            defaultPriceId,
            nextProductNativePrice,
            preserveCurrentPrice
          } = nextPriceData.value;
          originPriceList.value.forEach(item => {
            var _item$preserveCurrent, _item$startDate;
            // 1. 兼容性处理：保留原值或设为 null
            item.preserveCurrentPrice = (_item$preserveCurrent = item.preserveCurrentPrice) !== null && _item$preserveCurrent !== void 0 ? _item$preserveCurrent : null;
            item.startDate = (_item$startDate = item.startDate) !== null && _item$startDate !== void 0 ? _item$startDate : null;
            // 2. 查找匹配项
            const matched = nextProductNativePrice.find(ls => ls.regionName === item.regionName);
            // 3. 安全判断是否涨价（先确保 matched 存在）
            let isIncrease = false;
            if (matched) {
              const newPrice = Number(matched.prodPrice);
              const oldPrice = Number(item.prodPrice);
              // 确保价格是有效数字
              if (!isNaN(newPrice) && !isNaN(oldPrice)) {
                isIncrease = newPrice > oldPrice;
              }
            }
            // 4. 只有找到匹配项时才合并数据
            if (matched) {
              // 保留 item 原有的非覆盖字段，合并 matched，再覆盖 preserveCurrentPrice
              Object.assign(item, matched, {
                preserveCurrentPrice: isIncrease ? preserveCurrentPrice : null
                // 注意：startDate 等字段如果 matched 中没有，会被覆盖为 undefined！
              });
            }
            // 5. 删除不需要的属性
            delete item.price;
            delete item.key;
          });
          let upcomingPrices = {
            isDeleted: false,
            // preserveCurrentPrice, // 是否保持当前价格，当修改价格没有涨价时，此处为null
            regionCode,
            prodPrice,
            prodPriceCurrency,
            defaultPriceId: defaultPriceId || params.defaultPriceId,
            nextProductNativePrice: originPriceList.value
          };
          params.bizInfo.upcomingPrices = upcomingPrices;
        } else if (futurePriceList.value.length == 0 && params.bizInfo) {
          params.bizInfo.upcomingPrices = null;
        }
        if (isOriginHave && futurePriceList.value.length == 0 && params.bizInfo && originObj.value.bizInfo && originObj.value.bizInfo.upcomingPrices) {
          params.bizInfo.upcomingPrices = {
            ...originObj.value.bizInfo.upcomingPrices,
            isDeleted: true
          };
        }
        saveLoading.value = true;
        const fn = queryParams.value.id ? updGoods : addGoods;
        // 渠道ios+默认国家是sg则增加参数
        if (showRateSwitch.value) {
          params.bizInfo = {
            ...params.bizInfo,
            sgtPriceAdjustment: {
              enabled: taxRateSwitch.value
            }
          };
        } else {
          // 非调价区域增加参数处理
          params.bizInfo = {
            ...params.bizInfo,
            sgtPriceAdjustment: {
              enabled: false
            }
          };
        }
        const res = await fn(params);
        saveLoading.value = false;
        if (res.code === '0') {
          reportEvent({
            eventName: 'element_use',
            properties: {
              ui_name: 'ios商品配置',
              element_name: '保存'
            }
          });
          message.success('商品保存成功！');
          if (!saveNext.value) {
            router.push({
              name: 'goodsSetting'
            });
          } else {
            var _priceBlockRef$value12;
            // 连续创建时，初始化tab选择+清空enjoy输入内容
            priceTabKey.value = '1';
            thirdPartyPayment.value = {
              enabled: false,
              prodPrice: '',
              promotionDesc: ''
            };
            // 连续创建保留信息
            settingForm.value.productNativeInfo = params.productNativeInfo.map(item => {
              return {
                ...item,
                prodName: '',
                prodDescription: ''
              };
            });
            settingForm.value.prodId = settingForm.value.pkg;
            settingForm.value.prodPrice = '';
            settingForm.value.prodType = '';
            settingForm.value.remark = '';
            conturyPrice.value = [];
            defaultCountryId.value = '';
            settingForm.value.defaultPriceTier = '';
            (_priceBlockRef$value12 = priceBlockRef.value) === null || _priceBlockRef$value12 === void 0 || _priceBlockRef$value12.reset();
          }
        } else {}
      } catch (error) {}
    };
    // 判断是否有优惠方案
    const processProdGracePlan = prodGracePlanData => {
      if (prodGracePlanData) {
        return {
          regionConfigList: prodGracePlanData.regionConfigList.map(i => i.regionCode),
          type: prodGracePlanData.type,
          duration: prodGracePlanData.duration,
          productNativePrice: prodGracePlanData.productNativePrice,
          startDate: dayjs(prodGracePlanData.startDate),
          endDate: prodGracePlanData.endDate ? dayjs(prodGracePlanData.endDate) : ''
        };
      } else {
        return {
          regionConfigList: [],
          type: 'FREE_TRIAL',
          duration: 'THREE_DAYS',
          productNativePrice: [],
          startDate: '',
          endDate: ''
        };
      }
    };
    // ios 状态
    const iosStatus1 = ['MISSING_METADATA', 'READY_TO_SUBMIT', 'REJECTED', 'DEVELOPER_ACTION_NEEDED', 'DEVELOPER_REMOVED_FROM_SALE', 'REMOVED_FROM_SALE']; // 语言列表及价格可编辑
    const iosStatus2 = ['PENDING_BINARY_APPROVAL', 'WAITING_FOR_REVIEW', 'IN_REVIEW']; // 禁止编辑
    const iosStatus3 = ['APPROVED']; // 已存在的语言列表，仅可编辑商品名称+描述;不可删除已存在的语言列表;可新增语言;
    // const disabled1 = ref(false) // 语言列表及价格可编辑
    const disabled3 = ref(false); // 已存在的语言列表，仅可编辑商品名称+描述;不可删除已存在的语言列表;可新增语言;
    // 查询详情信息
    const getDetail = async () => {
      originLoading.value = true;
      const res = await queryGoods({
        id: queryParams.value.id
      });
      originLoading.value = false;
      if ((res === null || res === void 0 ? void 0 : res.code) === '0') {
        var _data$prodBasePlan, _data$prodBasePlan2, _data$channelPrices$p, _data$channelPrices, _priceBlockRef$value13;
        const {
          data
        } = res;
        originObj.value = cloneDeep(data);
        settingForm.value = {
          ...data,
          prodBasePlan: {
            // 订阅组
            id: (data === null || data === void 0 || (_data$prodBasePlan = data.prodBasePlan) === null || _data$prodBasePlan === void 0 ? void 0 : _data$prodBasePlan.id) || '',
            subscriptionType: '1',
            subscriptionPeriod: (data === null || data === void 0 || (_data$prodBasePlan2 = data.prodBasePlan) === null || _data$prodBasePlan2 === void 0 ? void 0 : _data$prodBasePlan2.subscriptionPeriod) || ''
          }
        };
        // 回显 enjoypay 渠道价格
        const enjoyPayInfo = (_data$channelPrices$p = data === null || data === void 0 || (_data$channelPrices = data.channelPrices) === null || _data$channelPrices === void 0 || (_data$channelPrices = _data$channelPrices.priceInfo) === null || _data$channelPrices === void 0 ? void 0 : _data$channelPrices.enjoy_pay) !== null && _data$channelPrices$p !== void 0 ? _data$channelPrices$p : null;
        if (enjoyPayInfo) {
          var _enjoyPayInfo$enableT, _enjoyPayInfo$prodPri, _enjoyPayInfo$promoti;
          thirdPartyPayment.value = {
            enabled: (_enjoyPayInfo$enableT = enjoyPayInfo.enableThirdPay) !== null && _enjoyPayInfo$enableT !== void 0 ? _enjoyPayInfo$enableT : false,
            prodPrice: (_enjoyPayInfo$prodPri = enjoyPayInfo.prodPrice) !== null && _enjoyPayInfo$prodPri !== void 0 ? _enjoyPayInfo$prodPri : '',
            promotionDesc: (_enjoyPayInfo$promoti = enjoyPayInfo.promotionDesc) !== null && _enjoyPayInfo$promoti !== void 0 ? _enjoyPayInfo$promoti : ''
          };
        }
        // comingPricesList.value = data.bizInfo.upcomingPrices
        defaultCountryId.value = data.regionCode;
        settingForm.value.defaultPriceTier = data.prodPrice;
        // 判断是否展示即将修改的逻辑
        if (data && data.bizInfo && data.bizInfo.upcomingPrices) {
          isDeletedShow.value = data.bizInfo.upcomingPrices.isDeleted;
          isOriginHave.value = data.bizInfo.upcomingPrices.nextProductNativePrice ? true : false; // 记录原始值做是否删除了保存判断
        }
        await calcSelectOptions();
        await changeProdPrice(data.prodPrice, true);
        // 编辑、查看时回显税率开关状态
        if (queryParams.value.type && ['edit', 'watch'].includes(queryParams.value.type) && showRateSwitch.value) {
          var _res$data$bizInfo$sgt, _res$data;
          taxRateSwitch.value = (_res$data$bizInfo$sgt = (_res$data = res.data) === null || _res$data === void 0 || (_res$data = _res$data.bizInfo) === null || _res$data === void 0 || (_res$data = _res$data.sgtPriceAdjustment) === null || _res$data === void 0 ? void 0 : _res$data.enabled) !== null && _res$data$bizInfo$sgt !== void 0 ? _res$data$bizInfo$sgt : false;
        }
        (_priceBlockRef$value13 = priceBlockRef.value) === null || _priceBlockRef$value13 === void 0 || _priceBlockRef$value13.init(data);
        // 保存一份最初的价格合集，用来处理调整区域列表
        originPriceList.value = data.productNativePrice;
        // 判断 data.appleState 属于哪个 iosStatus1 iosStatus2 iosStatus3 iosStatus4
        if (iosStatus1.includes(data.appleState)) {
          // disabled1.value = false
          // disabled.value = true
        } else if (iosStatus2.includes(data.appleState)) {
          disabled.value = true;
        } else if (iosStatus3.includes(data.appleState)) {
          disabled3.value = true;
        } else {
          // disabled.value = false
          // disabled3.value = true
        }
        multiComponentRef.value && (multiComponentRef.value.originData = cloneDeep(settingForm.value.productNativeInfo));
        nextTick(() => {
          // 增加处理逻辑-根据状态处理价格设置列表数据
          cPriceList.value = [{
            title: '最初价格',
            money: `${data.prodPriceCurrency} ${data.prodPrice}`,
            area: `${data.productNativePrice.length}个国家或地区`,
            areaList: data.productNativePrice.map(item => {
              return {
                name: `${item.regionName} (${item.prodPriceCurrency})`,
                total: `${item.prodPriceCurrency} ${item.prodPrice}`
              };
            }),
            desc: ''
          }];
          if (settingForm.value.prodType == '32') {
            prodGracePlan.value = processProdGracePlan(data.prodGracePlan);
            yhShow.value = !!data.prodGracePlan;
          }
          // 如果有即将生效的价格列表，则处理展示值
          if (data.bizInfo.upcomingPrices) {
            const {
              regionCode,
              defaultPriceId,
              prodPriceCurrency,
              prodPrice,
              nextProductNativePrice
            } = data.bizInfo.upcomingPrices;
            // 用originPriceList去跟nextProductNativePrice比对，只要prodPrice值不相同就把这一项过滤出来
            const filterList = nextProductNativePrice.filter(item => {
              return originPriceList.value.some(ls => ls.regionName === item.regionName && Number(ls.prodPrice) !== Number(item.prodPrice));
            });
            let desc = '',
              useFlag = null;
            if (filterList && filterList.length && filterList[0].preserveCurrentPrice === true) {
              desc = '为现有订阅者保持当前价格';
              useFlag = true;
            } else if (data.preserveCurrentPrice === false) {
              desc = '将价格上调应用于现有订阅者';
              useFlag = false;
            }
            const list = {
              title: '审核通过后次日生效',
              money: `${prodPriceCurrency} ${prodPrice}`,
              area: `${nextProductNativePrice.length}个国家或地区`,
              areaList: nextProductNativePrice.map(item => {
                return {
                  name: `${item.regionName} (${item.prodPriceCurrency})`,
                  total: `${item.prodPriceCurrency} ${item.prodPrice}`
                };
              }),
              desc: desc
            };
            futurePriceList.value[0] = list;
            nextPriceData.value = cloneDeep({
              regionCode,
              prodPrice,
              prodPriceCurrency,
              defaultPriceId,
              nextProductNativePrice: filterList,
              preserveCurrentPrice: useFlag
            });
          }
        });
      }
    };
    const nextPriceData = ref();
    const savePriceData = data => {
      nextPriceData.value = cloneDeep(data);
      isDeletedShow.value = false;
      // 接受到弹框数据后将修改信息回显处理
      let desc = '';
      if (data.preserveCurrentPrice === true) {
        desc = '为现有订阅者保持当前价格';
      } else if (data.preserveCurrentPrice === false) {
        desc = '将价格上调应用于现有订阅者';
      }
      const list = {
        title: '审核通过后次日生效',
        money: `${nextPriceData.value.prodPriceCurrency} ${nextPriceData.value.prodPrice}`,
        area: `${nextPriceData.value.nextProductNativePrice.length}个国家或地区`,
        areaList: nextPriceData.value.nextProductNativePrice.map(item => {
          return {
            name: `${item.regionName} (${item.prodPriceCurrency})`,
            total: `${item.prodPriceCurrency} ${item.prodPrice}`
          };
        }),
        desc: desc
      };
      futurePriceList.value[0] = list;
    };
    const queryLastLangInfo = async () => {
      const [err, res] = await awaitWrap(getLastLangInfo({
        dbtId: queryParams.value.dbtId,
        prodChnl: queryParams.value.prodChnl
      }));
      if (err) return void 0;
      if (res && res.code === OK) {
        var _res$data2, _res$data3;
        if (((_res$data2 = res.data) === null || _res$data2 === void 0 || (_res$data2 = _res$data2.lastLangInfos) === null || _res$data2 === void 0 ? void 0 : _res$data2.length) <= 1) return showLastLangInfo.value = false;
        showLastLangInfo.value = true;
        lastLangInfo.value = (_res$data3 = res.data) === null || _res$data3 === void 0 || (_res$data3 = _res$data3.lastLangInfos) === null || _res$data3 === void 0 ? void 0 : _res$data3.map(item => {
          return {
            ...item,
            prodDescription: '',
            prodName: ''
          };
        });
      }
    }; // 查询历史语言信息
    const changeLastLangInfo = () => {
      settingForm.value.productNativeInfo = lastLangInfo.value;
    }; // 修改历史语言信息
    const recordVisible = ref(false);
    const editRef = ref();
    const handleEdit = () => {
      var _editRef$value;
      (_editRef$value = editRef.value) === null || _editRef$value === void 0 || _editRef$value.openModal();
    };
    const deletePrice = () => {
      futurePriceList.value = [];
    };
    const showRateSwitch = computed(() => {
      return cCountry.value == 'SG' && queryParams.value.prodChnl == 'apple';
    }); // 渠道谷歌+默认币种是SGD则暂时税率开关
    const rateSwitchStatus = computed(() => {
      return queryParams.value.type === 'watch';
    }); // 详情时无法编辑税率开关
    onMounted(async () => {
      queryParams.value = {
        ...route.query
      };
      if (route.query.type === 'watch') {
        disabled.value = true;
      }
      await getCountryCoinOptions();
      await Promise.all([getPkg(), getPicker()]);
      await queryLastLangInfo();
      if (queryParams.value.id) {
        getDetail();
      }
    });
    return (_ctx, _cache) => {
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_switch = _resolveComponent("a-switch");
      const _component_a_spin = _resolveComponent("a-spin");
      const _component_a_popover = _resolveComponent("a-popover");
      const _component_a_tab_pane = _resolveComponent("a-tab-pane");
      const _component_a_input_number = _resolveComponent("a-input-number");
      const _component_a_form = _resolveComponent("a-form");
      const _component_a_tabs = _resolveComponent("a-tabs");
      const _component_svg_icon = _resolveComponent("svg-icon");
      const _component_a_date_picker = _resolveComponent("a-date-picker");
      const _component_a_checkbox = _resolveComponent("a-checkbox");
      return _openBlock(), _createBlock(_component_a_spin, {
        spinning: originLoading.value
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form, {
          ref_key: "myFormRef",
          ref: myFormRef,
          model: settingForm.value,
          "label-col": {
            style: 'width: 80px'
          },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [queryParams.value.id ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_a_button, {
            onClick: _cache[0] || (_cache[0] = () => {
              _unref(router).back();
            })
          }, {
            default: _withCtx(() => [_createTextVNode(" 返回 ")]),
            _: 1
          }), _createElementVNode("div", {
            class: "record-text",
            onClick: _cache[1] || (_cache[1] = $event => recordVisible.value = true)
          }, "变更记录")])) : _createCommentVNode("", true), _hoisted_4, _createVNode(_component_a_form_item, {
            label: "商品类型",
            name: "prodType",
            rules: [{
              required: true,
              type: 'string'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              class: "inputer",
              value: settingForm.value.prodType,
              "onUpdate:value": _cache[2] || (_cache[2] = $event => settingForm.value.prodType = $event),
              options: _unref(prodTypeOptions),
              onChange: changeProdType,
              disabled: Boolean(queryParams.value.id) || disabled.value
            }, {
              option: _withCtx(({
                label,
                describtion
              }) => [_createElementVNode("div", _hoisted_5, _toDisplayString(label), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(describtion), 1)]),
              _: 1
            }, 8, ["value", "options", "disabled"])]),
            _: 1
          }), _unref(isShowTicket) ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 1,
            label: "订阅组",
            name: ['prodBasePlan', 'id'],
            rules: [{
              required: true
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              disabled: Boolean(queryParams.value.id) || disabled.value,
              style: {
                "width": "360px",
                "display": "inline-block"
              },
              value: settingForm.value.prodBasePlan.id,
              "onUpdate:value": _cache[3] || (_cache[3] = $event => settingForm.value.prodBasePlan.id = $event),
              options: dyList.value,
              "field-names": {
                label: 'groupName',
                value: 'subGroupId'
              }
            }, null, 8, ["disabled", "value", "options"]), !Boolean(queryParams.value.id) ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              class: "ml8",
              type: "link",
              disabled: Boolean(queryParams.value.id) || disabled.value,
              onClick: clickDzAdd
            }, {
              default: _withCtx(() => [_createVNode(_unref(PlusOutlined)), _createTextVNode(" 新增订阅组 ")]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true)]),
            _: 1
          })) : _createCommentVNode("", true), _createVNode(_component_a_form_item, {
            label: "备注"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              class: "bigInputer",
              value: settingForm.value.remark,
              "onUpdate:value": _cache[4] || (_cache[4] = $event => settingForm.value.remark = $event),
              maxlength: 20,
              placeholder: "请输入",
              disabled: disabled.value
            }, null, 8, ["value", "disabled"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "商品信息",
            rules: [{
              required: true
            }]
          }, {
            default: _withCtx(() => [_createVNode(MultiComponents, {
              ref_key: "multiComponentRef",
              ref: multiComponentRef,
              filterItems: settingForm.value.productNativeInfo,
              onSetProdId: setProdId,
              disabled: disabled.value,
              disabled3: disabled3.value,
              onGetLastLange: changeLastLangInfo,
              showLastLangInfo: showLastLangInfo.value
            }, null, 8, ["filterItems", "disabled", "disabled3", "showLastLangInfo"])]),
            _: 1
          }), _createVNode(_component_a_form_item, {
            label: "内购ID",
            name: "prodId",
            rules: [{
              required: true,
              trigger: ['change', 'blur'],
              validator: _unref(validateIosPid)
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_input, {
              class: "inputer",
              value: settingForm.value.prodId,
              "onUpdate:value": _cache[5] || (_cache[5] = $event => settingForm.value.prodId = $event),
              placeholder: "请输入内购ID",
              disabled: Boolean(queryParams.value.id) || disabled.value,
              maxlength: 100
            }, null, 8, ["value", "disabled"]), _createVNode(_component_a_tooltip, {
              placement: "right"
            }, {
              title: _withCtx(() => [_hoisted_7]),
              default: _withCtx(() => [_createVNode(_unref(QuestionCircleOutlined), {
                class: "infoIcon ml8"
              })]),
              _: 1
            })]),
            _: 1
          }, 8, ["rules"]), _unref(isShowTicket) ? (_openBlock(), _createBlock(_component_a_form_item, {
            key: 2,
            label: "订阅时长",
            name: ['prodBasePlan', 'subscriptionPeriod'],
            rules: [{
              required: true,
              type: 'string'
            }]
          }, {
            default: _withCtx(() => [_createVNode(_component_a_select, {
              disabled: Boolean(queryParams.value.id) || disabled.value,
              style: {
                "width": "360px"
              },
              value: settingForm.value.prodBasePlan.subscriptionPeriod,
              "onUpdate:value": _cache[6] || (_cache[6] = $event => settingForm.value.prodBasePlan.subscriptionPeriod = $event),
              options: timeStep
            }, null, 8, ["disabled", "value"])]),
            _: 1
          })) : _createCommentVNode("", true), settingForm.value.prodType == '10' ? (_openBlock(), _createElementBlock("div", _hoisted_8, " *非消耗型商品，商品名称与商品描述请突出明显区别，否则发布将无法申请推广你的APP内购买项目 ")) : _createCommentVNode("", true)]), _createVNode(_component_a_tabs, {
            activeKey: priceTabKey.value,
            "onUpdate:activeKey": _cache[13] || (_cache[13] = $event => priceTabKey.value = $event),
            class: "ios-detail-tabs",
            tabBarStyle: {
              background: 'white'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "苹果官方价格"
            }, {
              default: _withCtx(() => [_withDirectives(_createVNode(_component_a_spin, {
                spinning: conturyPriceLoading.value
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createVNode(_component_a_form_item, {
                  label: "默认价格",
                  name: "defaultPriceTier",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_select, {
                    disabled: disabled.value,
                    getPopupContainer: _unref(getNode),
                    class: "selecter",
                    value: defaultCountryId.value,
                    "onUpdate:value": _cache[7] || (_cache[7] = $event => defaultCountryId.value = $event),
                    placholder: "请选择语言",
                    "filter-option": filterOption,
                    style: {
                      "width": "140px",
                      "margin-right": "12px"
                    },
                    onChange: calcSelectOptions,
                    "show-search": "",
                    options: defaultCountry.value,
                    "field-names": {
                      label: 'regionName',
                      value: 'regionCode'
                    }
                  }, null, 8, ["disabled", "getPopupContainer", "value", "options"]), _createVNode(_component_a_select, {
                    disabled: disabled.value,
                    class: "selecter",
                    "show-search": "",
                    value: settingForm.value.defaultPriceTier,
                    "onUpdate:value": _cache[8] || (_cache[8] = $event => settingForm.value.defaultPriceTier = $event),
                    style: {
                      "width": "140px",
                      "display": "inline-block"
                    },
                    placholder: "请选择价格",
                    onChange: changeProdPrice,
                    loading: conturyPriceLoading.value,
                    "field-names": {
                      label: 'prodPrice',
                      value: 'prodPrice'
                    },
                    options: conturyPrice.value
                  }, null, 8, ["disabled", "value", "loading", "options"])]),
                  _: 1
                }), _createVNode(_component_a_form_item, {
                  label: "本地价格",
                  rules: [{
                    required: true
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(PriceBlock2, {
                    "prod-type": settingForm.value.prodType,
                    dbtId: queryParams.value.dbtId,
                    "prod-chnl": queryParams.value.prodChnl,
                    "prod-price-currency": settingForm.value.prodPriceCurrency,
                    disabled: disabled.value,
                    originPriceList: originPriceList.value,
                    taxRateSwitch: taxRateSwitch.value,
                    ref_key: "priceBlockRef",
                    ref: priceBlockRef,
                    onUpdateList: handlePriceTierChange
                  }, null, 8, ["prod-type", "dbtId", "prod-chnl", "prod-price-currency", "disabled", "originPriceList", "taxRateSwitch"])]),
                  _: 1
                }), _unref(showRateSwitch) ? (_openBlock(), _createBlock(_component_a_form_item, {
                  key: 0,
                  label: "GST调价"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_a_switch, {
                    checked: taxRateSwitch.value,
                    "onUpdate:checked": _cache[9] || (_cache[9] = $event => taxRateSwitch.value = $event),
                    disabled: _unref(rateSwitchStatus) || conturyPriceLoading.value,
                    onChange: handlePriceTierChange
                  }, null, 8, ["checked", "disabled"]), _hoisted_12])]),
                  _: 1
                })) : _createCommentVNode("", true)])]),
                _: 1
              }, 8, ["spinning"]), [[_vShow, settingForm.value.prodType != '32' || settingForm.value.appleState != 'APPROVED']]), settingForm.value.prodType == '32' && queryParams.value.type && ['edit', 'watch'].includes(queryParams.value.type) && settingForm.value.appleState == 'APPROVED' ? (_openBlock(), _createBlock(_component_a_spin, {
                key: 0,
                spinning: priceTrend.value
              }, {
                default: _withCtx(() => [_createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_hoisted_15, _createTextVNode(" 价格设置 "), settingForm.value.prodType == '32' && queryParams.value.type && ['edit'].includes(queryParams.value.type) && settingForm.value.appleState == 'APPROVED' ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: "edit-price",
                  onClick: handleEdit
                }, " 修改订阅价格 ")) : _createCommentVNode("", true)]), settingForm.value.prodType == '32' && queryParams.value.type && ['edit', 'watch'].includes(queryParams.value.type) && settingForm.value.appleState == 'APPROVED' ? (_openBlock(), _createElementBlock("div", _hoisted_16, " 商品当前状态：" + _toDisplayString(_unref(statusText)), 1)) : _createCommentVNode("", true), _createElementVNode("ul", _hoisted_17, [futurePriceList.value.length > 0 && !isDeletedShow.value ? (_openBlock(), _createElementBlock("li", _hoisted_18, "即将生效价格")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(futurePriceList.value, (item, index) => {
                  return _withDirectives((_openBlock(), _createElementBlock("li", {
                    class: "l-item",
                    key: index,
                    style: {
                      "margin-bottom": "12px"
                    }
                  }, [_createElementVNode("span", _hoisted_19, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_20, _toDisplayString(item.money), 1), _createElementVNode("div", _hoisted_21, [_createVNode(_component_a_popover, {
                    overlayClassName: "popover-ios",
                    placement: "right"
                  }, {
                    content: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.areaList, (ls, index) => {
                      return _openBlock(), _createElementBlock("p", {
                        class: "popover-item",
                        key: index
                      }, [_createElementVNode("span", null, _toDisplayString(ls.name), 1), _createElementVNode("span", null, _toDisplayString(ls.total), 1)]);
                    }), 128))]),
                    title: _withCtx(() => [_hoisted_22]),
                    default: _withCtx(() => [_createElementVNode("span", null, [_createTextVNode(_toDisplayString(item.area) + " ", 1), _unref(showRateSwitch) && taxRateSwitch.value ? (_openBlock(), _createElementBlock("span", _hoisted_23, "(GST调价已开启)")) : _createCommentVNode("", true)])]),
                    _: 2
                  }, 1024)]), item.desc ? (_openBlock(), _createElementBlock("span", _hoisted_24, _toDisplayString(item.desc), 1)) : _createCommentVNode("", true), queryParams.value.type == 'edit' ? (_openBlock(), _createBlock(_unref(RestOutlined), {
                    key: 1,
                    class: "btn-icon",
                    onClick: deletePrice
                  })) : _createCommentVNode("", true)])), [[_vShow, !isDeletedShow.value]]);
                }), 128)), _hoisted_25, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cPriceList.value, (item, index) => {
                  return _openBlock(), _createElementBlock("li", {
                    class: "l-item",
                    key: index
                  }, [_createElementVNode("span", _hoisted_26, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_27, _toDisplayString(item.money), 1), _createElementVNode("div", _hoisted_28, [_createVNode(_component_a_popover, {
                    overlayClassName: "popover-ios",
                    placement: "right"
                  }, {
                    content: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.areaList, (ls, index) => {
                      return _openBlock(), _createElementBlock("p", {
                        class: "popover-item",
                        key: index
                      }, [_createElementVNode("span", null, _toDisplayString(ls.name), 1), _createElementVNode("span", null, _toDisplayString(ls.total), 1)]);
                    }), 128))]),
                    title: _withCtx(() => [_hoisted_29]),
                    default: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.area), 1)]),
                    _: 2
                  }, 1024)]), item.desc ? (_openBlock(), _createElementBlock("span", _hoisted_30, _toDisplayString(item.desc), 1)) : _createCommentVNode("", true)]);
                }), 128))])])]),
                _: 1
              }, 8, ["spinning"])) : _createCommentVNode("", true)]),
              _: 1
            }), settingForm.value.prodType == '20' ? (_openBlock(), _createBlock(_component_a_tab_pane, {
              key: "2",
              tab: "enjoypay"
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createVNode(_component_a_form, {
                model: thirdPartyPayment.value,
                "label-col": {
                  style: 'width: 98px'
                }
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  label: "开启三方支付"
                }, {
                  default: _withCtx(() => [_createElementVNode("div", _hoisted_32, [_createVNode(_component_a_switch, {
                    checked: thirdPartyPayment.value.enabled,
                    "onUpdate:checked": _cache[10] || (_cache[10] = $event => thirdPartyPayment.value.enabled = $event),
                    disabled: disabled.value
                  }, null, 8, ["checked", "disabled"]), _hoisted_33])]),
                  _: 1
                }), thirdPartyPayment.value.enabled ? (_openBlock(), _createElementBlock(_Fragment, {
                  key: 0
                }, [_createVNode(_component_a_form_item, {
                  label: "默认价格",
                  name: "prodPrice"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input_number, {
                    value: thirdPartyPayment.value.prodPrice,
                    "onUpdate:value": _cache[11] || (_cache[11] = $event => thirdPartyPayment.value.prodPrice = $event),
                    step: 0.01,
                    controls: false,
                    precision: 2,
                    "string-mode": "",
                    disabled: disabled.value,
                    style: {
                      "width": "140px"
                    },
                    "addon-after": "USD"
                  }, null, 8, ["value", "step", "disabled"]), _hoisted_34]),
                  _: 1
                }), _createVNode(_component_a_form_item, {
                  label: "折扣"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input_number, {
                    value: _unref(enjoyPayDiscountNum),
                    controls: false,
                    precision: 0,
                    readonly: "",
                    style: {
                      "width": "90px"
                    },
                    "addon-after": "%"
                  }, null, 8, ["value"])]),
                  _: 1
                }), _createVNode(_component_a_form_item, {
                  label: "折扣描述",
                  name: "promotionDesc"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    class: "bigInputer",
                    style: {
                      "width": "460px"
                    },
                    value: thirdPartyPayment.value.promotionDesc,
                    "onUpdate:value": _cache[12] || (_cache[12] = $event => thirdPartyPayment.value.promotionDesc = $event),
                    disabled: disabled.value,
                    placeholder: "请输入折扣描述"
                  }, null, 8, ["value", "disabled"]), _hoisted_35]),
                  _: 1
                })], 64)) : _createCommentVNode("", true)]),
                _: 1
              }, 8, ["model"])])]),
              _: 1
            })) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["activeKey"]), _unref(isShowTicket) ? (_openBlock(), _createBlock(_component_a_spin, {
            key: 0,
            spinning: spinning.value
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_hoisted_38, _createTextVNode(" 优惠方案 "), _createElementVNode("div", _hoisted_39, [yhShow.value ? (_openBlock(), _createBlock(_component_a_button, {
              key: 0,
              disabled: disabled.value,
              onClick: _cache[14] || (_cache[14] = $event => yhShowChange(false)),
              type: "link"
            }, {
              default: _withCtx(() => [_createVNode(_unref(DeleteOutlined)), _createTextVNode(" 删除优惠 ")]),
              _: 1
            }, 8, ["disabled"])) : _createCommentVNode("", true)])]), !yhShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createVNode(_component_svg_icon, {
              iconClass: "ticket",
              style: {
                "width": "78px",
                "height": "78px",
                "margin-top": "48px",
                "margin-bottom": "16px"
              }
            }), _hoisted_41, _createVNode(_component_a_button, {
              type: "link",
              style: {
                "margin-bottom": "24px"
              },
              disabled: disabled.value,
              onClick: _cache[15] || (_cache[15] = $event => yhShowChange(true))
            }, {
              default: _withCtx(() => [_createTextVNode(" 添加 ")]),
              _: 1
            }, 8, ["disabled"])])) : _createCommentVNode("", true), yhShow.value ? (_openBlock(), _createElementBlock("div", _hoisted_42, [_createVNode(_component_a_form, {
              model: prodGracePlan.value,
              "label-col": {
                style: 'width: 80px'
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_form_item, {
                label: "适用范围",
                name: "regionConfigList",
                required: ""
              }, {
                default: _withCtx(() => [_createElementVNode("span", {
                  style: {
                    "cursor": "pointer",
                    "color": "rgba(38, 72, 255, 1)"
                  },
                  class: "choose-country",
                  onClick: showCountryModal
                }, " 选择参与优惠的国家/地区 ")]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "生效时长",
                required: "",
                name: "startDate"
              }, {
                default: _withCtx(() => [_createVNode(_component_a_date_picker, {
                  disabled: disabled.value,
                  value: prodGracePlan.value.startDate,
                  "onUpdate:value": _cache[16] || (_cache[16] = $event => prodGracePlan.value.startDate = $event),
                  "disabled-date": disabledDate,
                  onChange: _cache[17] || (_cache[17] = () => {
                    prodGracePlan.value.endDate = '';
                  }),
                  placeholder: "请选择开始日期"
                }, null, 8, ["disabled", "value"]), _createTextVNode(" ~ "), _createVNode(_component_a_date_picker, {
                  allowClear: "",
                  "disabled-date": disabledDate1,
                  disabled: disabled.value,
                  value: prodGracePlan.value.endDate,
                  "onUpdate:value": _cache[19] || (_cache[19] = $event => prodGracePlan.value.endDate = $event),
                  placeholder: dataText.value,
                  ref_key: "endDate",
                  ref: endDate,
                  open: endDateOpen.value,
                  onFocus: _cache[20] || (_cache[20] = () => {
                    endDateOpen.value = true;
                  }),
                  onBlur: _cache[21] || (_cache[21] = () => {
                    endDateOpen.value = false;
                  })
                }, {
                  renderExtraFooter: _withCtx(() => [_createElementVNode("div", _hoisted_43, [_createVNode(_component_a_button, {
                    type: "text",
                    onClick: _cache[18] || (_cache[18] = () => {
                      ;
                      endDateOpen.value = false, dataText.value = '无结束日期';
                    })
                  }, {
                    default: _withCtx(() => [_createTextVNode(" 无结束日期 ")]),
                    _: 1
                  })])]),
                  _: 1
                }, 8, ["disabled", "value", "placeholder", "open"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "优惠类型",
                required: "",
                name: "type"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Select), {
                  disabled: disabled.value,
                  value: prodGracePlan.value.type,
                  "onUpdate:value": _cache[22] || (_cache[22] = $event => prodGracePlan.value.type = $event),
                  style: {
                    "width": "340px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_unref(SelectOption), {
                    value: "FREE_TRIAL"
                  }, {
                    default: _withCtx(() => [_createTextVNode("免费试订，订阅者在指定期限内无需付费")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["disabled", "value"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "优惠时长",
                required: "",
                name: "duration"
              }, {
                default: _withCtx(() => [_createVNode(_unref(Select), {
                  disabled: disabled.value,
                  value: prodGracePlan.value.duration,
                  "onUpdate:value": _cache[23] || (_cache[23] = $event => prodGracePlan.value.duration = $event),
                  style: {
                    "width": "340px"
                  }
                }, {
                  default: _withCtx(() => [_createVNode(_unref(SelectOption), {
                    value: "THREE_DAYS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("三天")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "ONE_WEEK"
                  }, {
                    default: _withCtx(() => [_createTextVNode("一周")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "TWO_WEEKS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("两周")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "ONE_MONTH"
                  }, {
                    default: _withCtx(() => [_createTextVNode("一个月")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "TWO_MONTHS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("两个月")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "THREE_MONTHS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("三个月")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "SIX_MONTHS"
                  }, {
                    default: _withCtx(() => [_createTextVNode("六个月")]),
                    _: 1
                  }), _createVNode(_unref(SelectOption), {
                    value: "ONE_YEAR"
                  }, {
                    default: _withCtx(() => [_createTextVNode("一年")]),
                    _: 1
                  })]),
                  _: 1
                }, 8, ["disabled", "value"])]),
                _: 1
              }), _createVNode(_component_a_form_item, {
                label: "本地价格"
              }, {
                default: _withCtx(() => [_createVNode(PriceBlock1, {
                  "prod-chnl": queryParams.value.prodChnl,
                  "prod-price-currency": settingForm.value.prodPriceCurrency,
                  disabled: disabled.value,
                  ref: "priceBlockRef1",
                  yhConturyPrice: _unref(yhConturyPrice),
                  "onUpdate:yhConturyPrice": _cache[24] || (_cache[24] = $event => _isRef(yhConturyPrice) ? yhConturyPrice.value = $event : null),
                  onUpdateList: changeProdPrice
                }, null, 8, ["prod-chnl", "prod-price-currency", "disabled", "yhConturyPrice"])]),
                _: 1
              })]),
              _: 1
            }, 8, ["model"])])) : _createCommentVNode("", true)])]),
            _: 1
          }, 8, ["spinning"])) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model"]), _withDirectives(_createElementVNode("div", _hoisted_44, [_createVNode(_component_a_button, {
          onClick: cancel
        }, {
          default: _withCtx(() => [_createTextVNode("取 消")]),
          _: 1
        }), _createVNode(_component_a_button, {
          loading: saveLoading.value,
          class: "ml8",
          type: "primary",
          onClick: save
        }, {
          default: _withCtx(() => [_createTextVNode("保 存")]),
          _: 1
        }, 8, ["loading"]), _withDirectives(_createElementVNode("div", _hoisted_45, [_createVNode(_component_a_checkbox, {
          checked: saveNext.value,
          "onUpdate:checked": _cache[25] || (_cache[25] = $event => saveNext.value = $event)
        }, {
          default: _withCtx(() => [_createTextVNode("连续创建")]),
          _: 1
        }, 8, ["checked"])], 512), [[_vShow, !queryParams.value.id]])], 512), [[_vShow, !disabled.value]]), _createVNode(SelectModal, {
          "read-only": disabled.value,
          "model-visible": visible.value,
          "onUpdate:model-visible": _cache[26] || (_cache[26] = $event => visible.value = $event),
          title: "选择国家/地区",
          "all-list": _unref(allData),
          onSaveData: saveCountry,
          "edit-item": _unref(yhContury)
        }, null, 8, ["read-only", "model-visible", "all-list", "edit-item"]), _createVNode(DyzModal, {
          ref_key: "dzmodal",
          ref: dzmodal,
          modalVisible: modalVisible.value,
          "onUpdate:modalVisible": _cache[27] || (_cache[27] = $event => modalVisible.value = $event),
          dbtId: queryParams.value.dbtId,
          prodChnl: queryParams.value.prodChnl,
          onUpdateList: refreshDy
        }, null, 8, ["modalVisible", "dbtId", "prodChnl"]), _createVNode(EditModal, {
          ref_key: "editRef",
          ref: editRef,
          goodsInfo: settingForm.value,
          showRateSwitch: _unref(showRateSwitch),
          taxRateSwitch: taxRateSwitch.value,
          areaList: _unref(allAreaList),
          originPriceList: originPriceList.value,
          onSendNextPriceData: savePriceData
        }, null, 8, ["goodsInfo", "showRateSwitch", "taxRateSwitch", "areaList", "originPriceList"]), _createVNode(RecordDrawer, {
          visible: recordVisible.value,
          "onUpdate:visible": _cache[28] || (_cache[28] = $event => recordVisible.value = $event)
        }, null, 8, ["visible"])])]),
        _: 1
      }, 8, ["spinning"]);
    };
  }
});